import React, { useEffect, useRef, useState } from "react";
import { get } from "../../utility/fetchWeb";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import { CircularProgress, Typography, Button } from "@mui/material";

function ZoomMeeting({
  meetingNumber,
  userName,
  userEmail,
  password,
  role = 0,
  zak,
}) {
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);
  const zoomRootRef = useRef(null);

  useEffect(() => {
    if (!meetingNumber) {
      setError("Meeting number is required");
      setStatus("error");
      return;
    }

    console.log(password);
    console.log(zak);

    const checkAndInit = async () => {
      if (!zoomRootRef.current) {
        setTimeout(checkAndInit, 100);
        return;
      }

      try {
        setStatus("loading");
        setError(null);

        const res = await get("/appointment/generate-zoom-signature", {
          meetingNumber,
          role,
        });

        if (!res?.signature) {
          throw new Error("Failed to retrieve Zoom signature");
        }

        const client = ZoomMtgEmbedded.createClient();

        await client.init({
          zoomAppRoot: zoomRootRef.current,
          language: "en-US",
          patchJsMedia: true,
        });

        client.on("meeting-status", (payload) => {
          console.log("Meeting status changed:", payload);

          if (payload.meetingStatus === "MEETING_STATUS_ENDED") {
            setStatus("ended");
            console.log(status);
          }
        });

        await client.join({
          sdkKey: 'HmOShDlmTpSK72149FL_yg',
          signature: res.signature,
          meetingNumber,
          zak,
          userName,
          password,
        });

        setStatus("joined");
      } catch (err) {
        console.error("Zoom init/join error:", err);
        setError(err.message || "Failed to join Zoom meeting.");
        setStatus("error");
      }
    };

    checkAndInit();
  }, [meetingNumber]);

  return (
    <>
      {status === "loading" && (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <CircularProgress />
          <Typography variant="body1" style={{ marginTop: "1rem" }}>
            Connecting to Zoom meeting...
          </Typography>
        </div>
      )}

      {status === "error" && (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <Typography variant="h6" color="error" gutterBottom>
            Failed to join meeting
          </Typography>
          <Typography variant="body1" gutterBottom>
            {error}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
            style={{ marginTop: "1rem" }}
          >
            Try Again
          </Button>
        </div>
      )}

      {/* Always render this container */}
      <div
        ref={zoomRootRef}
        id="meetingSDKElement"
        style={{
          display: status === "joined" ? "block" : "none",
          width: "50%",
          height: " 50vh",
        }}
      />
    </>
  );
}

export default ZoomMeeting;
